<script setup>
import moment from "moment-timezone";
import CardHolderIndex from "@/components/card-holders/CardHolderIndex.vue";
import CardHolderExport from "@/components/card-holders/CardHolderExport.vue";

moment.tz.setDefault("Asia/Jakarta");

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Card Holders";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];

const route = useRoute();
const router = useRouter();

const navigationTab = ref(route.query.export ? 2 : 0);
const tabItems = ["Search", "Import", "Export"];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Search {{ pageTitle }}</h4>
  <VCard>
    <VTabs v-model="navigationTab">
      <VTab v-for="item in tabItems" :key="item">
        {{ item }}
      </VTab>
    </VTabs>
    <VWindow v-model="navigationTab">
      <VWindowItem :key="tabItems[0]">
        <CardHolderIndex />
      </VWindowItem>
      <VWindowItem :key="tabItems[1]">
        <CardHolderImport />
      </VWindowItem>
      <VWindowItem :key="tabItems[2]">
        <CardHolderExport />
      </VWindowItem>
    </VWindow>
  </VCard>
</template>
